import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static values = { paramsToRemove: Array }

    connect() {
        this.removeQueryParams();
    }

    removeQueryParams() {
        const url = new URL(window.location);
        this.paramsToRemoveValue.forEach(param => {
            if (url.searchParams.has(param)) {
                url.searchParams.delete(param);
            }
        });
        window.history.replaceState({}, '', url);
    }

}